import humps from 'humps';
import { toastr } from 'react-redux-toastr';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _findIndex from 'lodash/findIndex';
import _size from 'lodash/size';
import { addDownloadDetails, mapAssignCounterparties } from 'app/utils/TransactionUtils.tsx';
import * as fetchUtils from 'app/utils/FetchUtils';
import { createLoadingSelector } from 'app/reducers/loading';
import { validateObj, checkNumberOrString } from 'app/utils/CommonUtils';
import { getTasks } from 'app/reducers/ncd/transaction/tasks';
import { REPAYMENT_SCHEDULE, RS_FILE, DEAL_DOCUMENTS } from 'app/constants/TransactionConstants';
import { PRODUCT_KEYS, TRANSACTION_STATE } from 'app/constants/Constants';
import { PRODUCT_RELEASE_CLICK } from 'app/constants/AmplitudeActions';
import { EventTypes } from 'app/utils/reduxAmplitude';

const createActionName = (name) => `app/admin/ncd/${name}`;

export const TRANSACTION_NCD_REQUEST = createActionName('TRANSACTION_NCD_REQUEST');
export const TRANSACTION_NCD_SUCCESS = createActionName('TRANSACTION_NCD_SUCCESS');
export const TRANSACTION_NCD_FAILURE = createActionName('TRANSACTION_NCD_FAILURE');
export const NCD_UPLOAD_REQUEST = createActionName('NCD_UPLOAD_REQUEST');
export const NCD_UPLOAD_SUCCESS = createActionName('NCD_UPLOAD_SUCCESS');
export const FILE_UPLOAD_SUCCESS = createActionName('FILE_UPLOAD_SUCCESS');
export const FILE_UPLOAD_REQUEST = createActionName('FILE_UPLOAD_REQUEST');
export const NCD_UPLOAD_FAILURE = createActionName('NCD_UPLOAD_FAILURE');
export const NCD_BIDS_SUCCESS = createActionName('NCD_BIDS_SUCCESS');
export const NCD_GET_EXEC_DOCS_SUCCESS = createActionName('NCD_GET_EXEC_DOCS_SUCCESS');

export const ADHOC_CREATE_REQUEST = createActionName('ADHOC_CREATE_REQUEST');
export const ADHOC_CREATE_SUCCESS = createActionName('ADHOC_CREATE_SUCCESS');
export const ADHOC_CREATE_FAILURE = createActionName('ADHOC_CREATE_FAILURE');

export const ADHOC_UPDATE_REQUEST = createActionName('ADHOC_UPDATE_REQUEST');
export const ADHOC_UPDATE_SUCCESS = createActionName('ADHOC_UPDATE_SUCCESS');
export const ADHOC_UPDATE_FAILURE = createActionName('ADHOC_UPDATE_FAILURE');

export const PLACEHOLDER_REMOVE_REQUEST = createActionName('PLACEHOLDER_REMOVE_REQUEST');
export const PLACEHOLDER_REMOVE_SUCCESS = createActionName('PLACEHOLDER_REMOVE_SUCCESS');
export const PLACEHOLDER_REMOVE_FAILURE = createActionName('PLACEHOLDER_REMOVE_FAILURE');

export const ADD_ATTACHMENT_REQUEST = createActionName('ADD_ATTACHMENT_REQUEST');
export const ADD_ATTACHMENT_SUCCESS = createActionName('ADD_ATTACHMENT_SUCCESS');
export const ADD_ATTACHMENT_FAILURE = createActionName('ADD_ATTACHMENT_FAILURE');

export const DELETE_ATTACHMENT_REQUEST = createActionName('DELETE_ATTACHMENT_REQUEST');
export const DELETE_ATTACHMENT_SUCCESS = createActionName('DELETE_ATTACHMENT_SUCCESS');
export const DELETE_ATTACHMENT_FAILURE = createActionName('DELETE_ATTACHMENT_FAILURE');

export const isNCDLoading = createLoadingSelector([createActionName('TRANSACTION_NCD')]);
export const isAdhocLoading = createLoadingSelector([createActionName('ADHOC_CREATE')]);
export const isAdhocUpdating = createLoadingSelector([createActionName('ADHOC_UPDATE')]);
export const placeholderRemoving = createLoadingSelector([createActionName('PLACEHOLDER_REMOVE')]);

export const FUNDING_STATUS_REQUEST = createActionName('FUNDING_STATUS_REQUEST');
export const FUNDING_STATUS_SUCCESS = createActionName('FUNDING_STATUS_SUCCESS');
export const FUNDING_STATUS_FAILURE = createActionName('FUNDING_STATUS_FAILURE');

const initialState = {
    dealNameUpdate: false,
};

const initialStampDuty = {
    deedOfHypothecation: {
        amount: '',
    },
    debentureTrustDeed: {
        amount: '',
    },
    debentureTrusteeAgreement: {
        amount: '',
    },
    debentureCertificate: {
        amount: '',
    },
};

export default function details(state = initialState, action) {
    switch (action.type) {
        case TRANSACTION_NCD_SUCCESS:
            return {
                ...state,
                ...action.data,
                documents: addDownloadDetails(_get(action, 'data')),
            };
        case NCD_GET_EXEC_DOCS_SUCCESS:
            return {
                ...state,
                execDocs: action.data.execDocs,
                otherDocs: action.data.others,
            };
        case ADD_ATTACHMENT_SUCCESS: {
            const { data: newAttachment } = action;
            let cloneExtraDocs = _get(state, 'extraDocuments', []);
            const attachmentIndex = _findIndex(cloneExtraDocs, ['files[0].fileId', _get(newAttachment, 'fileId')]);

            if (attachmentIndex >= 0) {
                cloneExtraDocs[attachmentIndex] = { files: [{ ...newAttachment }] };
            } else {
                cloneExtraDocs = [{ files: [{ ...newAttachment }] }, ...cloneExtraDocs];
            }

            return {
                ...state,
                extraDocuments: cloneExtraDocs,
            };
        }
        case DELETE_ATTACHMENT_SUCCESS: {
            const { attachmentId } = action;
            const cloneExtraDocs = _get(state, 'extraDocuments', []);
            const deleteIndex = cloneExtraDocs.findIndex((item) => _get(item, 'files[0].fileId') === attachmentId);
            if (deleteIndex >= 0) cloneExtraDocs.splice(deleteIndex, 1);
            return {
                ...state,
                extraDocuments: cloneExtraDocs,
            };
        }
        default:
            return state;
    }
}

export const mapStampDuty = (data) => {
    const formCopy = { ...data };
    formCopy.deedOfHypothecation = {
        ...formCopy.deedOfHypothecation,
        firstPartyData: {
            id: _get(formCopy, 'deedOfHypothecation.firstPartyData.value'),
            name: _get(formCopy, 'deedOfHypothecation.firstPartyData.label'),
        },
        secondPartyData: {
            id: _get(formCopy, 'deedOfHypothecation.secondPartyData.value'),
            name: _get(formCopy, 'deedOfHypothecation.secondPartyData.label'),
        },
    };
    formCopy.debentureTrustDeed = {
        ...formCopy.debentureTrustDeed,
        firstPartyData: {
            id: _get(formCopy, 'debentureTrustDeed.firstPartyData.value'),
            name: _get(formCopy, 'debentureTrustDeed.firstPartyData.label'),
        },
        secondPartyData: {
            id: _get(formCopy, 'debentureTrustDeed.secondPartyData.value'),
            name: _get(formCopy, 'debentureTrustDeed.secondPartyData.label'),
        },
    };
    formCopy.debentureTrusteeAgreement = {
        ...formCopy.debentureTrusteeAgreement,
        firstPartyData: {
            id: _get(formCopy, 'debentureTrusteeAgreement.firstPartyData.value'),
            name: _get(formCopy, 'debentureTrusteeAgreement.firstPartyData.label'),
        },
        secondPartyData: {
            id: _get(formCopy, 'debentureTrusteeAgreement.secondPartyData.value'),
            name: _get(formCopy, 'debentureTrusteeAgreement.secondPartyData.label'),
        },
    };
    formCopy.debentureCertificate = {
        ...formCopy.debentureCertificate,
        firstPartyData: {
            id: _get(formCopy, 'debentureCertificate.firstPartyData.value'),
            name: _get(formCopy, 'debentureCertificate.firstPartyData.label'),
        },
        secondPartyData: {
            id: _get(formCopy, 'debentureCertificate.secondPartyData.value'),
            name: _get(formCopy, 'debentureCertificate.secondPartyData.label'),
        },
    };
    return humps.decamelizeKeys({ stampDuty: formCopy });
};

export const unMapStampDuty = (initialValues) => {
    const initialValuesCopy = { ...initialValues };
    initialValuesCopy.deedOfHypothecation = {
        ...initialValuesCopy.deedOfHypothecation,
        firstPartyData: {
            value: _get(initialValuesCopy, 'deedOfHypothecation.firstPartyData.id'),
            label: _get(initialValuesCopy, 'deedOfHypothecation.firstPartyData.name'),
        },
        secondPartyData: {
            value: _get(initialValuesCopy, 'deedOfHypothecation.secondPartyData.id'),
            label: _get(initialValuesCopy, 'deedOfHypothecation.secondPartyData.name'),
        },
    };
    initialValuesCopy.debentureTrustDeed = {
        ...initialValuesCopy.debentureTrustDeed,
        firstPartyData: {
            value: _get(initialValuesCopy, 'debentureTrustDeed.firstPartyData.id'),
            label: _get(initialValuesCopy, 'debentureTrustDeed.firstPartyData.name'),
        },
        secondPartyData: {
            value: _get(initialValuesCopy, 'debentureTrustDeed.secondPartyData.id'),
            label: _get(initialValuesCopy, 'debentureTrustDeed.secondPartyData.name'),
        },
    };
    initialValuesCopy.debentureTrusteeAgreement = {
        ...initialValuesCopy.debentureTrusteeAgreement,
        firstPartyData: {
            value: _get(initialValuesCopy, 'debentureTrusteeAgreement.firstPartyData.id'),
            label: _get(initialValuesCopy, 'debentureTrusteeAgreement.firstPartyData.name'),
        },
        secondPartyData: {
            value: _get(initialValuesCopy, 'debentureTrusteeAgreement.secondPartyData.id'),
            label: _get(initialValuesCopy, 'debentureTrusteeAgreement.secondPartyData.name'),
        },
    };
    initialValuesCopy.debentureCertificate = {
        ...initialValuesCopy.debentureCertificate,
        firstPartyData: {
            value: _get(initialValuesCopy, 'debentureCertificate.firstPartyData.id'),
            label: _get(initialValuesCopy, 'debentureCertificate.firstPartyData.name'),
        },
        secondPartyData: {
            value: _get(initialValuesCopy, 'debentureCertificate.secondPartyData.id'),
            label: _get(initialValuesCopy, 'debentureCertificate.secondPartyData.name'),
        },
    };
    return initialValuesCopy;
};

function unMapNcd(data) {
    let prcessData = {};
    const ratingAgencyIds = [];
    const lawFirmIds = [];
    const registrarIds = [];
    const trusteeIds = [];

    if (data.ratingAgencyIds) ratingAgencyIds.push(data.ratingAgencyIds);
    if (data.lawFirmIds) lawFirmIds.push(data.lawFirmIds);
    if (data.trusteeIds) trusteeIds.push(data.trusteeIds);
    if (data.registrarIds) registrarIds.push(data.registrarIds);

    prcessData = {
        bondType: data.bondType,
        issuanceSize: data.issuanceSize * 10000000,
        interest: data.interest,
        principalAmmortization: data.principalAmmortization,
        interestPayout: data.interestPayout,
        issueDate: data.issueDate,
        maturityDate: data.maturityDate,
        tenor: {
            years: data.tenor.years ? parseInt(data.tenor.years, 10) : 0,
            months: data.tenor.months ? parseInt(data.tenor.months, 10) : 0,
            days: data.tenor.days ? parseInt(data.tenor.days, 10) : 0,
        },
        rating: (data.rating && data.rating.value) || '',
        ratingAgencyIds,
        lawFirmIds,
        registrarIds,
        trusteeIds,
        issuance: data.issuance,
        faceValue: data.faceValue,
        repaymentType: data.repaymentType,
        principalMoratorium: !checkNumberOrString(data.principalMoratorium) ? data.principalMoratorium : null,
        interestMoratorium: !checkNumberOrString(data.interestMoratorium) ? data.interestMoratorium : null,
        dsra: data.dsra ? data.dsra : null,
        escrowAccount: data.escrowAccount ? data.escrowAccount : null,
        putOption: data.putOption ? data.putOption : null,
        callOption: data.callOption ? data.callOption : null,
        redemptionAmount: _isEmpty(data.redemptionAmount) ? data.redemptionAmount : {},
        interestRateResetOption: {
            ...(_get(data, 'interestRateResetOption.ratingChange.percentageChange')
                ? { ratingChange: { percentageChange: data.interestRateResetOption.ratingChange.percentageChange } }
                : {}),
            ...(_get(data, 'interestRateResetOption.callOption.percentageChange')
                ? { callOption: { percentageChange: data.interestRateResetOption.callOption.percentageChange } }
                : {}),
            ...(_get(data, 'interestRateResetOption.others.percentageChange')
                ? {
                      others: {
                          label: data.interestRateResetOption.others.label,
                          percentageChange: data.interestRateResetOption.others.percentageChange,
                      },
                  }
                : {}),
        },
        disbursementDate: data.disbursementDate ? data.disbursementDate : null,
        processingFee: data.processingFee ? data.processingFee : 0,
        interestMethod: data.interestMethod ? data.interestMethod : null,
    };
    if (validateObj(data, ['protection', 'isSharePledge'])) {
        prcessData = {
            ...prcessData,
            protection: {
                ...prcessData.protection,
                sharePledge: {
                    percentage: data.protection.sharePledge.percentage,
                },
            },
        };
    }
    if (validateObj(data, ['protection', 'isImmovablePropertyMortgage'])) {
        prcessData = {
            ...prcessData,
            protection: {
                ...prcessData.protection,
                immovablePropertyMortgage: {
                    percentage: data.protection.immovablePropertyMortgage.percentage,
                },
            },
        };
    }
    if (validateObj(data, ['feeApplicableOn'])) {
        prcessData = {
            ...prcessData,
            feeApplicableOn: data.feeApplicableOn,
        };
    }
    if (validateObj(data, ['protection', 'security'])) {
        prcessData = {
            ...prcessData,
            protection: {
                ...prcessData.protection,
                security: {
                    chargeType: data.protection.security.chargeType,
                    securityCover: data.protection.security.securityCover,
                },
            },
        };
    }
    if (validateObj(data, ['protection', 'cashCollateral'])) {
        prcessData = {
            ...prcessData,
            protection: {
                ...prcessData.protection,
                cashCollateral: {
                    percentage: data.protection.cashCollateral.percentage,
                    resetFrequency: data.protection.cashCollateral.resetFrequency,
                },
            },
        };
    }
    if (validateObj(data, ['trancheDisbursements']) && data.trancheDisbursements.some((m) => m.trancheAmount !== null)) {
        prcessData = {
            ...prcessData,
            trancheDisbursements: data.trancheDisbursements,
        };
    }
    if (validateObj(data, ['protection']) && validateObj(data, ['protection', 'corporateGuarantee']) !== 'undefined') {
        prcessData = {
            ...prcessData,
            protection: {
                ...prcessData.protection,
                corporateGuarantee: data.protection.isCorporate ? data.protection.corporateGuarantee : [],
            },
        };
    }
    if (validateObj(data, ['protection']) && validateObj(data, ['protection', 'promoterGuarantee']) !== 'undefined') {
        prcessData = {
            ...prcessData,
            protection: {
                ...prcessData.protection,
                promoterGuarantee: data.protection.isPromoter ? data.protection.promoterGuarantee : [],
            },
        };
    }
    return humps.decamelizeKeys(prcessData);
}

function mapNCD(data) {
    let ratingAgency = {};
    let lawFirms = [];
    let trustees = {};
    let investors = {};
    let registrars = {};
    let acceptedInvestors;
    const corporateGuarantee = [
        {
            name: null,
            address: null,
            cin: null,
        },
    ];
    const promoterGuarantee = [
        {
            name: null,
            address: null,
            passportNo: null,
        },
    ];
    if (data.rating_agencies.length > 0) {
        ratingAgency = data.rating_agencies
            .map((m) => ({
                value: m.id,
                label: m.name,
            }))
            .reduce((r) => r);
    }
    if (data.law_firms.length > 0) {
        if (_size(data.law_firms) > 0) {
            lawFirms = data.law_firms.map((m) => ({
                value: m.id,
                label: m.name,
            }));
        } else {
            lawFirms = [];
        }
    }
    if (data.trustees.length > 0) {
        trustees = data.trustees
            .map((m) => ({
                value: m.id,
                label: m.name,
            }))
            .reduce((r) => r);
    }
    if (data.registrars.length > 0) {
        registrars = data.registrars
            .map((m) => ({
                value: m.id,
                label: m.name,
            }))
            .reduce((r) => r);
    }
    if (data.investors.length > 0) {
        investors = data.investors
            .map((m) => ({
                value: m.id,
                label: m.name,
            }))
            .reduce((r) => r);
    }
    if (data.accepted_investors.length > 0) {
        acceptedInvestors = data.accepted_investors.map((m) => ({
            value: m.id,
            label: m.name,
        }));
    }
    const prcessData = {
        ...data,
        clientId: data.customerId || (Array.isArray(data.customer) && data.customer.length > 0 && data.customer[0].id) || '',
        issuanceSize: data.issuance_size / 10000000,
        ratingAgencyIds: ratingAgency.value ? ratingAgency : { value: 'N/A', label: 'N/A' },
        lawFirmIds: lawFirms,
        trusteeIds: trustees.value ? trustees : { value: 'N/A', label: 'N/A' },
        investorsIds: investors,
        registrarIds: registrars,
        acceptedInvestors,
        needLegalAssistance: data.law_firms && data.law_firms.length > 0,
        rating: data.rating
            ? {
                  valid: true,
                  value: data.rating,
              }
            : { valid: false },
        faceValue: data.face_value,
        tenor: {
            days: data.tenor.days === null ? 0 : data.tenor.days,
            months: data.tenor.months === null ? 0 : data.tenor.months,
            years: data.tenor.years === null ? 0 : data.tenor.years,
        },
        principalMoratoriumStatus: !checkNumberOrString(data.principal_moratorium),
        interestMoratoriumStatus: !checkNumberOrString(data.interest_moratorium),
        redemptionPremium: !!data.redemption_amount,
        putOptionStatus: !!data.put_option,
        callOptionStatus: !!data.call_option,
        protection: {
            ...data.protection,
            securityStatus: !!_get(data, 'protection.security.charge_type'),
            isCorporate: !!_get(data, 'protection.corporate_guarantee[0]'),
            isPromoter: !!_get(data, 'protection.promoter_guarantee[0]'),
            cc: !!_get(data, 'protection.cash_collateral.percentage'),
            isSharePledge: _get(data, 'protection.share_pledge') && Object.keys(_get(data, 'protection.share_pledge')).length > 0,
            isImmovablePropertyMortgage:
                _get(data, 'protection.immovable_property_mortgage') && Object.keys(_get(data, 'protection.immovable_property_mortgage')).length > 0,
            corporate_guarantee:
                data.protection && data.protection.corporate_guarantee && data.protection.corporate_guarantee.length > 0
                    ? data.protection.corporate_guarantee
                    : corporateGuarantee,
            promoter_guarantee:
                data.protection && data.protection.promoter_guarantee && data.protection.promoter_guarantee.length > 0
                    ? data.protection.promoter_guarantee
                    : promoterGuarantee,
        },
        interestRateResetOption: {
            ...data.interest_rate_reset_option,
            ratingChangeStatus: !!_get(data, 'interest_rate_reset_option.rating_change.percentage_change'),
            nonExerciseStatus: !!_get(data, 'interest_rate_reset_option.call_option.percentage_change'),
            othersStatus: !!_get(data, 'interest_rate_reset_option.others.percentage_change'),
        },
        stampDuty: _isEmpty(data.stamp_duty) ? initialStampDuty : data.stamp_duty,
    };
    return humps.camelizeKeys(prcessData);
}

export function getNcd(id) {
    return (dispatch) => {
        dispatch({ type: TRANSACTION_NCD_REQUEST });
        fetchUtils
            .getJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}`)
            .then((d) => mapNCD(d))
            .then((d) => dispatch({ type: TRANSACTION_NCD_SUCCESS, data: d, id }))
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    dispatch({ type: TRANSACTION_NCD_FAILURE });
                    toastr.error('Error retrieving NCD data', m);
                }),
            );
    };
}

export function updateNcd(id, data) {
    return (dispatch) => {
        const payload = unMapNcd(data);
        return fetchUtils
            .putJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}`, {
                ncd_transaction: payload,
            })
            .then((d) => mapNCD(d))
            .then((d) => {
                toastr.success('Success!', 'NCD data updated.');
                dispatch({ type: TRANSACTION_NCD_SUCCESS, data: d, id });
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating NCD data', m);
                }),
            );
    };
}

export function updateNcdState(id, data, setSubmitting) {
    return (dispatch) => {
        dispatch({ type: TRANSACTION_NCD_REQUEST });
        return fetchUtils
            .putJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}`, {
                ncd_transaction: data,
            })
            .then((d) => mapNCD(d))
            .then((d) => {
                if (typeof setSubmitting === 'function') {
                    setSubmitting(false);
                }
                toastr.success('Success!', 'NCD State Updated.');
                dispatch({ type: TRANSACTION_NCD_SUCCESS, data: d, id });
            })
            .then(() => {
                if (_get(data, 'transaction_state') === TRANSACTION_STATE.RELEASED) {
                    dispatch({
                        type: PRODUCT_RELEASE_CLICK,
                        meta: {
                            amplitude: [
                                {
                                    eventType: EventTypes.track,
                                    eventPayload: {
                                        eventName: PRODUCT_RELEASE_CLICK,
                                        transaction_type: PRODUCT_KEYS.ncd,
                                        transactionId: id,
                                        ...data,
                                    },
                                },
                            ],
                        },
                    });
                }
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating NCD State', m);
                    dispatch({ type: TRANSACTION_NCD_FAILURE });
                }),
            );
    };
}

export function editDealName(transId, values) {
    return (dispatch) =>
        fetchUtils
            .putJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}`, {
                ncd_transaction: { ...humps.decamelizeKeys(values), id: transId },
            })
            .then((d) => humps.camelizeKeys(d))
            .then((d) => {
                dispatch({ type: TRANSACTION_NCD_SUCCESS, data: { ...d, dealNameUpdate: true }, id: transId });
                toastr.success('Success!', 'Deal Name updated successfully');
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating deal name', m);
                }),
            );
}

/* Start of Legal Documents */
export function uploadLegalDocuments(transId, file, fileType) {
    return (dispatch) => {
        dispatch({ type: FILE_UPLOAD_REQUEST });
        const body = new FormData();
        body.append('document', file);
        const isRS = fileType === REPAYMENT_SCHEDULE;
        body.append('document_type', isRS ? RS_FILE : fileType);

        return fetchUtils
            .postFormData(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/${isRS ? RS_FILE : DEAL_DOCUMENTS}`, body)
            .then((d) => {
                dispatch({ type: FILE_UPLOAD_SUCCESS, data: d });
                dispatch(getNcd(transId));
                return d;
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error uploading pool file', m);
                    throw new Error(m);
                }),
            );
    };
}

export function destroyLegalDocuments(fileId, transId) {
    return (dispatch) =>
        fetchUtils
            .deleteJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/deal_documents/${fileId}`)
            .then(() => {
                toastr.success('File Destroyed');
                dispatch(getNcd(transId));
            })
            .catch((ex) => {
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error destroying transaction file', m);
                });
            });
}

export function removeLegalPlaceholder(transId, data) {
    return (dispatch) => {
        dispatch({ type: PLACEHOLDER_REMOVE_REQUEST });
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/remove_document`, humps.decamelizeKeys(data))
            .then(() => {
                dispatch({ type: PLACEHOLDER_REMOVE_SUCCESS });
                dispatch(getNcd(transId));
                toastr.success('Success!', 'Document placeholder has been removed successfully');
            })
            .catch((ex) => {
                dispatch({ type: PLACEHOLDER_REMOVE_FAILURE });
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error removing placeholder', m);
                });
            });
    };
}
/* End of Legal Documents */

/* Start of Adhoc Documents */

const formatAdHocData = (values) => {
    const data = {
        document: values,
    };
    return humps.decamelizeKeys(data);
};

export function addAdhocDocument(transId, data) {
    return (dispatch) => {
        dispatch({ type: ADHOC_CREATE_REQUEST });
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/add_document`, formatAdHocData(data))
            .then(() => {
                dispatch({ type: ADHOC_CREATE_SUCCESS });
                dispatch(getNcd(transId));
                toastr.success('Success!', 'Adhoc document has been created successfully');
            })
            .catch((ex) => {
                dispatch({ type: ADHOC_CREATE_FAILURE });
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error adding document', m);
                });
            });
    };
}

export function updateAdhocDocument(transId, data) {
    return (dispatch) => {
        dispatch({ type: ADHOC_UPDATE_REQUEST });
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/modify_document`, humps.decamelizeKeys(data))
            .then(() => {
                dispatch({ type: ADHOC_UPDATE_SUCCESS });
                dispatch(getNcd(transId));
                toastr.success('Success!', 'Document settings has been updated successfully');
            })
            .catch((ex) => {
                dispatch({ type: ADHOC_UPDATE_FAILURE });
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating settings', m);
                });
            });
    };
}

/* End of Adhoc Documents */

/* Start of Executed Documents */

export function getNCDExecDocs(id) {
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}/executable_documents`)
            .then((d) => humps.camelizeKeys(d))
            .then((d) => {
                const docs = d.documents.filter((doc) => doc.files.length > 0);
                const others = d.otherFiles;
                const isGenerated = docs.every((item) => item.files[0].state === 'generated');
                const isFailed = docs.some((item) => item.files[0].state === 'failed');
                if (_get(d, 'errorMessage')) {
                    return _get(d, 'errorMessage');
                }
                if (!docs.length && others.length) {
                    dispatch({ type: NCD_GET_EXEC_DOCS_SUCCESS, data: { execDocs: docs, others: d.otherFiles }, id });
                    return null;
                }
                if (isFailed) {
                    return docs;
                } else if (isGenerated) {
                    dispatch({ type: NCD_GET_EXEC_DOCS_SUCCESS, data: { execDocs: docs, others: d.otherFiles }, id });
                    return docs;
                }
                return null;
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error fetching documents', m);
                }),
            );
}

export function pollNCDExecDocs(id) {
    return (dispatch) =>
        fetchUtils
            .poll(() => dispatch(getNCDExecDocs(id)), 180000, 3000)
            .then((d) => {
                if (!Array.isArray(d)) {
                    toastr.error('Error Finalizing Documents', d);
                } else if (!d.length) {
                    toastr.error('Error Finalizing Documents', 'Failed to generate executed documents');
                } else if (d.some((item) => item.files[0].state === 'failed')) {
                    toastr.error(
                        'Error Finalizing Documents',
                        `Please check the format of ${humps.pascalize(d.find((item) => item.files[0].state === 'failed').files[0].type)}`,
                    );
                } else {
                    toastr.success('Success!', 'Documents generated successfully.');
                }
            })
            .catch((e) => {
                const errMsg = (e && e.message) || 'Something went wrong, please try again after sometime';
                if (errMsg === 'timeout') {
                    toastr.error('Timeout Generating Documents', 'Please try again after sometime.');
                } else {
                    toastr.error('Error Polling Documents', errMsg);
                }
            });
}

export function generateExecDocs(transId, setSubmitting) {
    toastr.success('Success!', 'Documents generation Request initiated');
    return (dispatch) =>
        fetchUtils
            .postJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/executable_documents`)
            .then(() => dispatch(pollNCDExecDocs(transId)))
            .then(() => setSubmitting(false))
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error Generating Documents', m);
                }),
            );
}

export function revokeExecDocs(id) {
    return (dispatch) =>
        fetchUtils
            .postJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}/executable_documents/revoke`)
            .then((d) => {
                if (_get(d, 'success')) {
                    dispatch(getNCDExecDocs(id));
                } else {
                    toastr.error('Failed to revoke executable documents');
                }
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error revoking executable documents', m);
                }),
            );
}

/* End of Executed Documents */

// Actors
const mapActors = (data) => {
    let prcessData = {};
    const { ratingAgencyIds, lawFirmIds, trusteeIds, registrarIds } = data;
    prcessData = mapAssignCounterparties({ ratingAgencyIds, lawFirmIds, trusteeIds, registrarIds });
    return humps.decamelizeKeys(prcessData);
};

export function updateActors(id, actors) {
    return (dispatch) =>
        fetchUtils
            .putJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}`, {
                ncd_transaction: mapActors(actors),
            })
            .then((d) => mapNCD(d))
            .then((d) => {
                toastr.success('Success!', 'Counterparties updated.');
                dispatch({ type: TRANSACTION_NCD_SUCCESS, data: d, id });
                dispatch(getTasks(id));
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error updating counterparties', m);
                }),
            );
}

function getNCDDocs(id) {
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}`)
            .then((d) => mapNCD(d))
            .then((d) => {
                const docs = _get(d, 'documents', []).filter((doc) => doc.files.length > 0);
                const isGenerated = docs.every((item) => item.files[0].state === 'generated' || item.files[0].state === 'uploaded');
                dispatch({ type: TRANSACTION_NCD_SUCCESS, data: d, id });
                if (isGenerated && docs.length > 0) return d;
                return null;
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error fetching Documents', m);
                }),
            );
}

export function pollingNCDDocs(id) {
    return (dispatch) =>
        fetchUtils
            .poll(() => dispatch(getNCDDocs(id)), 180000, 1000)
            .then((d) => {
                dispatch({ type: TRANSACTION_NCD_SUCCESS, data: d, id });
                toastr.success('Success!', 'Documents generated successfully.');
            })
            .catch((e) => {
                const errMsg = (e && e.message) || 'Something went wrong, please try again after sometime';
                if (errMsg === 'timeout') {
                    toastr.error('Timeout Generating Documents', 'Please try again after sometime.');
                } else {
                    toastr.error('Error Generating Documents', errMsg);
                }
            });
}

export function generateDocuments(transId) {
    return (dispatch) =>
        fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/generate_documents`, {})
            .then((d) => humps.camelizeKeys(d))
            .then((d) => {
                dispatch({ type: TRANSACTION_NCD_SUCCESS, data: d, id: transId });
            })
            .then(() => {
                toastr.success('Success!', 'Documents generation initiated successfully.');
            })
            .then(() => dispatch(pollingNCDDocs(transId)))
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error Generating Documents', m);
                }),
            );
}

export function addAttachment(transId, data, attachmentId, callBack) {
    return (dispatch) => {
        dispatch({ type: ADD_ATTACHMENT_REQUEST });
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/extra_documents/${attachmentId}`, humps.decamelizeKeys(data))
            .then((attachment) => {
                dispatch({ type: ADD_ATTACHMENT_SUCCESS, data: humps.camelizeKeys(attachment), id: transId });
                if (typeof callBack === 'function') callBack();
            })
            .catch((ex) => {
                dispatch({ type: ADD_ATTACHMENT_FAILURE });
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error adding attachment', m);
                    if (typeof callBack === 'function') callBack();
                });
            });
    };
}

export function deleteAttachment(transId, attachmentId, callBack) {
    return (dispatch) => {
        dispatch({ type: DELETE_ATTACHMENT_REQUEST });
        return fetchUtils
            .deleteJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${transId}/extra_documents/${attachmentId}`)
            .then(() => {
                dispatch({ type: DELETE_ATTACHMENT_SUCCESS, attachmentId, id: transId });
                if (typeof callBack === 'function') callBack();
            })
            .catch((ex) => {
                dispatch({ type: DELETE_ATTACHMENT_FAILURE });
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error removing attachment', m);
                    if (typeof callBack === 'function') callBack();
                });
            });
    };
}

export function getNCDState(id) {
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}`)
            .then((d) => mapNCD(d))
            .then((d) => {
                if ([TRANSACTION_STATE.SETTLED, TRANSACTION_STATE.MATURED].includes(d.transactionState)) {
                    dispatch({ type: TRANSACTION_NCD_SUCCESS, data: d, id });
                    return d;
                }

                return null;
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    return new Error(m);
                }),
            );
}

export function pollNCDState(id, callback) {
    return (dispatch) => {
        return fetchUtils
            .poll(() => dispatch(getNCDState(id)), 180000, 1000)
            .then(() => {
                toastr.success('Success!', 'Transaction state updated successfully.');
                if (typeof callback === 'function') callback();
            })
            .catch((e) => {
                const errMsg = (e && e.message) || 'Something went wrong, please try again after sometime';
                if (errMsg === 'timeout') {
                    toastr.error('Timeout retrieving transaction state', 'Please try again after sometime.');
                } else {
                    toastr.error('Error retrieving transaction state', errMsg);
                }
                if (typeof callback === 'function') callback();
            });
    };
}

export function updateNcdStatus(id, values, callback) {
    return (dispatch) => {
        dispatch({ type: FUNDING_STATUS_REQUEST });
        return fetchUtils
            .patchJSON(`${process.env.REACT_APP_CREDBOND_API_HOST}/ncds/${id}`, { ncd_transaction: { ...humps.decamelizeKeys(values), id } })
            .then((d) => humps.camelizeKeys(d))
            .then(() => dispatch(pollNCDState(id, callback)))
            .then(() => {
                if (values.direct_settlement) {
                    dispatch({ type: FUNDING_STATUS_SUCCESS });
                    toastr.success('Success!', 'Transaction status updated.');
                }
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    dispatch({ type: FUNDING_STATUS_FAILURE });
                    toastr.error('Error while updating', m);
                }),
            );
    };
}
